/// <reference path="../../../shared/custom-typings/svg.d.ts" />
import polcoLogo from 'client/assets/polco-logo-dark-text.svg';
import * as React from 'react';
import './styles.scss';
import { getConfig } from 'client/shared/core/config';
import { AppLink } from 'client/shared/components/base';

const baseClass = 'pn-embed-header';

export const EmbedHeader: React.FC = () => {
  return (
    <div className={`${baseClass} d-flex flex-row py-3 px-3`}>
      <img alt="Polco" src={polcoLogo} />
      <div className="flex-grow-1"></div>
      <div className={`${baseClass}-title font-size-sm`}>
        Make your voice heard on{' '}
        <AppLink target="_blank" to={getConfig().siteUrl}>
          Polco.us
        </AppLink>
      </div>
    </div>
  );
};
EmbedHeader.displayName = 'EmbedHeader';
